import PrivacyTerms from '@/components/PrivacyTerms'
import SiteFooter from '@/components/SiteFooter'
import SiteHeader from '@/components/SiteHeader'
import Seo from '@/components/Seo'
import PublicBirds from '@/components/public/PublicBirds'
import { ShieldCheck } from 'lucide-react'

export default function PrivacyPage() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <Seo path="/privacy" />
      <SiteHeader />

      <main className="flex-1">
        <div className="relative">
          <PublicBirds className="hidden sm:block" />
          <section className="relative mx-auto w-full max-w-4xl px-5 pb-10 pt-12 sm:pt-16">
          <p className="text-[11px] font-semibold uppercase tracking-[0.18em] text-muted-foreground">
            Privacy &amp; Terms
          </p>
          <h1 className="mt-3 text-3xl font-semibold tracking-tight sm:text-4xl">
            Your census never leaves your browser.
          </h1>
          <div className="mt-6 grid gap-5 border border-border bg-card p-5 sm:grid-cols-[auto_1fr] sm:items-center sm:p-6">
            <div className="flex h-12 w-12 items-center justify-center border border-border bg-brand-soft">
              <ShieldCheck className="h-6 w-6 text-brand" aria-hidden="true" />
            </div>
            <p className="text-sm leading-7 text-muted-foreground">
              The short version: employee census data stays on your device, calculations run locally, and the
              numbers here are estimates, not advice. The full policy and terms below spell out exactly what is
              and isn&apos;t stored.
            </p>
          </div>
          </section>
        </div>

        <section className="border-t border-border bg-card">
          <div className="mx-auto w-full max-w-4xl px-5 py-10 sm:py-12">
            <PrivacyTerms />
          </div>
        </section>
      </main>
      <SiteFooter />
    </div>
  )
}
